import { initializeAnalytics } from "@repo/analytics/instrumentation-client";
import { initializeSentry } from "@repo/observability/client";
import * as Sentry from "@sentry/nextjs";

initializeSentry();
initializeAnalytics();

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
